<template>
  <div class="all">
    <div class="IntegralExchange_tab">
      <el-row style="margin:10px 0;">
        <el-col :span="2">
          <div class="IntegralExchange_tab_One">
            一级分类:
          </div>
        </el-col>
        <el-col :span="21">
          <div class="IntegralExchange_tab_Two" :class="type==1?'avieHei':'avieMin'">
            <span v-for="(item,key) in ClassList" :key="key" @click="getClass(item.id)"
                  :style="item.id == class_id?'background: #ff9049;color:#fff':''">{{item.name}}</span>
          </div>
        </el-col>
        <el-col :span="1">
          <div class="IntegralExchange_tab_Three" @click="getType(type)">
            {{type == 1?'更多':'收起'}}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="IntegralExchange_shop">
      <div class="focusoncommodities_bot_two">
        <div class="focusoncommodities_bot_onw_for" v-for="(shop,index) in shopdata" :key="index">
          <div class="focusoncommodities_bot_onw_for_img" @click="gettiaoye(shop.id,shop.goods_id)">
            <img :src="$store.state.Url+shop.img" alt="">
          </div>
          <div class="focusoncommodities_bot_onw_for_text" @click="gettiaoye(shop.id,shop.goods_id)">
            <span>{{shop.name}}</span>
          </div>
          <div class="focusoncommodities_bot_onw_for_shop">
            <div class="focusoncommodities_bot_onw_for_shop_left" @click="gettiaoye(shop.id,shop.goods_id)">
              <span>积分：{{shop.price}}</span>
            </div>
            <div class="focusoncommodities_bot_onw_for_shop_right" @click="getduihuan(shop.id)">
              <span></span>
              立即兑换
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Myinte,getsduihuan} from '../api/Mycen'

  export default {
    name: "IntegralExchange",
    data() {
      return {
        type: 1,
        class_id: '',
        shopdata: [],
        ClassList: [],
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      gettiaoye(id,goodsid){
        this.$router.push({path:'/detailsjifen',query:{id:id,goodsid:goodsid}})
      },
      getduihuan(id) {
        this.$confirm('是否兑换此商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getsduihuan({
            id:id
          }).then(res=>{

          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      getType(e) {
        if (e == 1) {
          this.type = 2
        } else {
          this.type = 1
        }
      },
      init() {
        Myinte({
          class_id: this.class_id
        }).then(res => {
          this.ClassList = res.class
          this.shopdata = res.data
        })
      },
      getClass(id) {
        this.class_id = id
        this.init()
      },
    }
  }
</script>

<style scoped lang="less">
  @import "css/IntegralExchange";
</style>



// WEBPACK FOOTER //
// src/components/IntegralExchange.vue